import { CreditCard, ClipboardList, MessageCircle, Send } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";
import { PRECIO_MENSUAL } from "@/config";

const pasos = [
  {
    number: "01",
    icon: CreditCard,
    title: `Únete por ${PRECIO_MENSUAL} € al mes`,
    text: "Completa el pago mensual seguro.",
  },
  {
    number: "02",
    icon: ClipboardList,
    title: "Completa tu acceso",
    text: "Introduce tu nombre, correo electrónico y número de WhatsApp.",
  },
  {
    number: "03",
    icon: MessageCircle,
    title: "Entra en la comunidad privada",
    text: "Recibe las instrucciones y el acceso al grupo o comunidad de WhatsApp.",
  },
  {
    number: "04",
    icon: Send,
    title: "Comparte cuando lo necesites",
    text: "Participa a tu ritmo, inicia conversaciones o responde a otros miembros.",
  },
];

export const ComoFunciona = () => (
  <section id="como-funciona" className="bg-[#0B1120] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[1100px]">
      <Reveal>
        <ChapterLabel number="04" testId="chapter-como-funciona" />
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Puedes estar dentro en pocos minutos.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="como-funciona-steps">
        {pasos.map((paso, i) => (
          <Reveal key={paso.number} delay={0.07 * i} className="h-full">
            <div
              data-testid={`como-funciona-step-${i + 1}`}
              className="flex h-full flex-col rounded-2xl border border-[#22304D] bg-[#131D33] p-7 transition-[transform,border-color] duration-200 hover:-translate-y-1 hover:border-[#8B7CF6]/40"
            >
              <div className="flex items-center justify-between">
                <span className="font-[Fraunces] text-4xl font-semibold text-[#8B7CF6]/25">
                  {paso.number}
                </span>
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#8B7CF6]/10 text-[#8B7CF6]">
                  <paso.icon className="h-5 w-5" strokeWidth={1.5} />
                </div>
              </div>
              <h3 className="mt-6 text-lg font-semibold leading-snug text-[#F5F1EA]">
                {paso.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#9AA6BE]">
                {paso.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
